module.exports = __webpack_public_path__ + "static/media/1_pl.75d980c1.png";